import React from 'react';
import { ModalDialog } from 'react-bootstrap';
import Draggable from 'react-draggable';

export const DraggableModalDialog = (props) => {
    return (
        <Draggable handle='.modal-header'><ModalDialog {...props}/></Draggable>
    );
}   